export const LOADER_STATUS = 'boilderplate/EWBRECO_RECONCILATION/LOADER_STATUS';
export const SET_ENTITY_LIST = 'boilderplate/EWBRECO_RECONCILATION/SET_ENTITY_LIST';
export const SELECTED_ENTITY = 'boilderplate/EWBRECO_RECONCILATION/SELECTED_ENTITY';
export const PROFILE_DATA = 'boilderplate/EWBRECO_RECONCILATION/PROFILE_DATA';
export const SELECTED_GSTINS = 'boilderplate/EWBRECO_RECONCILATION/SELECTED_GSTINS';
export const STORE_PERIOD = 'boilderplate/EWBRECO_RECONCILATION/STORE_PERIOD';
export const SET_MULTIPLE_GSTIN_DATA = 'boilderplate/EWBRECO_RECONCILATION/SET_MULTIPLE_GSTIN_DATA';
export const SET_SUMMARY_DATA = 'boilderplate/EWBRECO_RECONCILATION/SET_SUMMARY_DATA';
export const TABLE_DATA = 'boilderplate/EWBRECO_RECONCILATION/TABLE_DATA';
export const CHECKED_RUN_FY = 'boilderplate/EWBRECO_RECONCILATION/CHECKED_RUN_FY';
export const SET_RECO_HISTORY_TABLE_DATA = 'boilderplate/EWBRECO_RECONCILATION/SET_RECO_HISTORY_TABLE_DATA';
export const SAVE_TOTAL_PAGES = 'boilderplate/EWBRECO_RECONCILATION/SAVE_TOTAL_PAGES';


export const recoType = [
    {
        label: "Inward",
        value: "Inward (PR vs Inward E-Way Bill)",
    },
    {
        label: "Outward",
        value: "Outward (3 Way Reconciliation)",
    },
];